import { render } from "./IntentionSetterV1.vue?vue&type=template&id=2ff5da0c&scoped=true"
import script from "./IntentionSetterV1.vue?vue&type=script&lang=js"
export * from "./IntentionSetterV1.vue?vue&type=script&lang=js"

import "./IntentionSetterV1.vue?vue&type=style&index=0&id=2ff5da0c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff5da0c"]])

export default __exports__